/* global gdAlertify */
import React, { useEffect, useState } from "react";
import axiosInstance from "../../config/axiosConfig";

const ConfiguracionHonorarios = () => {
    const [config, setConfig] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchConfig();
    }, []);

    const fetchConfig = async () => {
        setLoading(true);
        try {
            const { data } = await axiosInstance.get("/configuracion/honorarios/lista");
            setConfig(data.data || []);
        } catch (error) {
            console.error("Error al obtener la configuración", error);
            gdAlertify.notiError("Error al cargar la configuración");
        } finally {
            setLoading(false);
        }
    };

    const handleValueChange = (clave, valor) => {
        const nextConfig = config.map(c => {
            if (c.clave === clave) return { ...c, valor };
            return c;
        });
        setConfig(nextConfig);
    };

    const handleSave = async () => {
        const payload = {
            configs: config.reduce((acc, c) => {
                acc[c.clave] = c.valor;
                return acc;
            }, {})
        };

        try {
            gdAlertify.showLoader();
            await axiosInstance.post("/configuracion/honorarios/guardar", payload);
            gdAlertify.notiSuccess("Configuración guardada correctamente");
        } catch (error) {
            console.error("Error al guardar", error);
            gdAlertify.notiError("Error al guardar los cambios");
        } finally {
            gdAlertify.hideLoader();
        }
    };

    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                    <h4 className="mb-0">Configuración de Resumen de Honorarios</h4>
                    <button className="btn btn-primary" onClick={handleSave}>
                        <i className="bi bi-save me-2"></i>Guardar Cambios
                    </button>
                </div>
                <div className="card-body">
                    <p className="text-muted mb-4">
                        Modifica aquí los textos que aparecen al final del reporte de "Resumen de Pago". 
                        Puedes usar Markdown o HTML básico si es necesario. Si dejas un campo vacío, no se mostrará en el resumen.
                    </p>

                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status"></div>
                            <p className="mt-2">Cargando configuración...</p>
                        </div>
                    ) : (
                        <div className="row g-4">
                            {config.map((item) => (
                                <div className="col-12" key={item.clave}>
                                    <div className="p-3 border rounded bg-light">
                                        <div className="d-flex justify-content-between mb-2">
                                            <label className="fw-bold">{item.descripcion || item.clave}</label>
                                            <span className="badge bg-secondary">{item.clave}</span>
                                        </div>
                                        <textarea
                                            className="form-control"
                                            rows="4"
                                            value={item.valor || ""}
                                            onChange={(e) => handleValueChange(item.clave, e.target.value)}
                                            placeholder="Escribe el texto aquí..."
                                        ></textarea>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div className="card-footer d-flex justify-content-end">
                    <button className="btn btn-success px-4" onClick={handleSave}>
                        <i className="bi bi-check-lg me-2"></i>Guardar Cambios
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfiguracionHonorarios;
